<template>
  <div class="mt-4 p-4 border border-gray-200 dark:border-gray-700 rounded-lg bg-gray-50 dark:bg-gray-800/50">
    <h3 class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">
      Crear Nuevo Cliente
    </h3>
    <CustomerForm
      @saved="$emit('saved', $event)"
      @cancel="$emit('cancel')"
    />
  </div>
</template>

<script setup lang="ts">
import CustomerForm from './CustomerForm.vue';
import type { Customer } from '@/types/customer';

interface Emits {
  (e: 'saved', customer: Customer): void;
  (e: 'cancel'): void;
}

defineEmits<Emits>();
</script>
